import { rafThrottle } from 'Components/00-basics/utilities';

(function() {
  function updateActionButtonCallback(buttonEl, subjectEl) {
    return function () {
      var mainTop = subjectEl.getBoundingClientRect().top;
      var isVisible = buttonEl.style.display != "none";

      if (mainTop <= 0 && !isVisible) {
        buttonEl.style.display = "";
      }
      else if (mainTop > 0 && isVisible) {
        buttonEl.style.display = "none";
      }
    }
  }

  var button = document.getElementById('action-scroll-top');
  var subject = document.getElementsByTagName('main')[0];

  if (!button || !subject) return;

  var cb = updateActionButtonCallback(button, subject);
  cb();

  document.addEventListener('scroll', function () {
    rafThrottle(500, cb);
  });
}())
